export default function createDefaultMediaProductUtil ({ imageUrl }) {
  return {
    id: 42,
    image: { url: imageUrl },
    previewImage: { url: imageUrl },
    mediaContentType: 'IMAGE'
  }
}
